import React, { useState, useEffect, useRef } from "react";
import themeStyles from "../../../shared/styles/theme/theme-styles.module.scss";
import styles from "./styles.module.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const CustomSelect = (props) => {
  const {
    options,
    value,
    name,
    label,
    placeholder,
    errors,
    className,
    classInput,
    horizontal,
    onSelect = (value) => {},
    onChange = (e) => {},
  } = props;
  const [expanded, setExpanded] = useState(false);
  const [indexSelected, setIndexSelected] = useState(-1);
  const ref = useRef(null);

  useEffect(() => {
    const index = options.findIndex((item) => item.value === value);

    if (index > -1) {
      setIndexSelected(index);
    }
  }, [value, options]);

  const handleOnClick = () => {
    ref.current.focus();
    setExpanded(!expanded);
  };

  const handleOnSelect = (value, index) => {
    onSelect(value);
    setExpanded(false);
    setIndexSelected(index);
    const e = new Event("change");
    ref.current.value = value;
    ref.current.dispatchEvent(e);
  };

  useEffect(() => {
    ref.current.onchange = (e) => {
      onChange(e);
    };
  }, []);

  const contains = (parent, child) => {
    if (!child || !child.parentElement) return false;
    if (child.parentElement === parent) return true;

    return contains(parent, child.parentElement);
  };

  const handleOnBlur = (e) => {
    const target = e.relatedTarget;
    const parent = e.currentTarget;
    if (!contains(parent, target)) {
      setExpanded(false);
      // onBlur();
    }
  };

  const getInputGroupClassNames = () => {
    return classNames({
      [className]: !!className,
    });
  };

  const getInputClassNames = () => {
    return classNames({
      [styles.inputSelect]: !classInput,
      [classInput]: !!classInput,
      [styles.focus]: expanded && props.focus,
    });
  };

  return (
    <div
      className={`${getInputGroupClassNames()} ${styles.column}`}
      style={{
        flexDirection: horizontal ? "row" : "",
        alignItems: horizontal ? "center" : "",
      }}
    >
      {label && (
        <label
          className={styles.formLabel}
          style={{ marginRight: horizontal ? "1em" : "" }}
        >
          {label}
        </label>
      )}
      <div
        className={`${styles.selectBox} ${getInputClassNames()}`}
        onBlur={handleOnBlur}
        onClick={handleOnClick}
        tabIndex="1"
      >
        <i
          className={`${
            !expanded ? themeStyles.iconAngleDown : themeStyles.iconAngleUp
          } ${styles.icon}`}
        />
        <input
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`${styles.input} ${
            errors && errors[name] ? styles.error : ""
          }`}
          ref={ref}
          readOnly
          hidden
        />
        <div
          className={`${styles.valueSelected} ${
            errors && errors[name] ? styles.error : ""
          }`}
        >
          {indexSelected === -1
            ? placeholder
            : options[indexSelected].valueDisplay ||
              options[indexSelected].value}
        </div>
        {errors && errors[name] && (
          <small className={styles.errors}>{errors && errors[name]}</small>
        )}
        <div className={styles.overSelect} />

        <div
          className={`${styles.containerSearch} ${expanded && styles.expanded}`}
        >
          <div className={styles.items}>
            {options &&
              options.map((option, i) => {
                return (
                  <label
                    key={i}
                    tabIndex="1"
                    onClick={() => handleOnSelect(option.value, i)}
                    className={i === indexSelected ? styles.Active : ""}
                  >
                    {option.valueDisplay || option.value}
                  </label>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

CustomSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      valueDisplay: PropTypes.string,
    })
  ),
};
export default CustomSelect;
